import { JobMatchQueryFilter } from "../../../../../models/jobMatchQueryFilter";
var MatchedCandidatesContainer = /** @class */ (function () {
    function MatchedCandidatesContainer(userId, companyId, jobId, associateCandidatesDefaultFilter, jobDetails, pageSize, jobMatchService, jobService, candidateService, alertsAndNotificationsService) {
        this.userId = userId;
        this.companyId = companyId;
        this.jobId = jobId;
        this.associateCandidatesDefaultFilter = associateCandidatesDefaultFilter;
        this.jobDetails = jobDetails;
        this.pageSize = pageSize;
        this.jobMatchService = jobMatchService;
        this.jobService = jobService;
        this.candidateService = candidateService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$onInit();
    }
    MatchedCandidatesContainer.prototype.$onInit = function () {
        this.candidates = [];
        this.selectedCandidates = [];
        this.busy = false;
        this.candidatesExistFlag = true;
        this.defaultPageSize = this.pageSize;
        this.searchObject = new SearchObject(this.jobId, this.companyId, this.pageSize, this.associateCandidatesDefaultFilter, this.jobDetails.fourDotFiveIntelligenceScore);
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
        this.searchByTextFlag = false;
        this.totalCandidateCount = null;
        this.selectAllDoneFlag = false;
        this.topMatches = 0;
        this.isFilterOn = false;
    };
    MatchedCandidatesContainer.prototype.getNext = function () {
        var _this = this;
        if (this.busy)
            return;
        this.busy = true;
        if (this.searchObject.page == '') {
            this.searchObject.page = 1;
        }
        var tempSearchObject = angular.copy(this.searchObject);
        if (this.searchByTextFlag) {
            delete tempSearchObject.minimumScore;
            delete tempSearchObject.maximumScore;
        }
        else {
            delete tempSearchObject.searchText;
        }
        if (tempSearchObject.numberOfDays == 0) {
            delete tempSearchObject.numberOfDays;
        }
        this._setIsFilterOn(tempSearchObject);
        tempSearchObject.loggedInUserId = this.userId;
        this.currentPromise = this.jobService.findMatchingCandidatesForJob(tempSearchObject, function (data) {
            if (_this.searchObject.page == 1) {
                // if it is first page, reset the candidates/data array.
                _this.candidates = [];
            }
            if (angular.isDefined(data) && data != 'user cancellation') {
                _this.totalCandidateCount = data.count;
                if (data.candidateMinimumInfoDtos.length > 0) {
                    angular.forEach(data.candidateMinimumInfoDtos, function (val, key) {
                        var basicCandidateInfo = _this._getBasicCandidateInfo(val);
                        var currentIndex = _this.candidates.length;
                        if (((currentIndex + 1) % 3) == 1) {
                            basicCandidateInfo.jobMatchesPopoverPosition = 'bottom-left';
                        }
                        else if (((currentIndex + 1) % 3) == 0) {
                            basicCandidateInfo.jobMatchesPopoverPosition = 'bottom-right';
                        }
                        _this.getCandidateJobMatches(basicCandidateInfo.id, _this.userId, _this.companyId, function (data) {
                            basicCandidateInfo.candidateJobMatches = data;
                            basicCandidateInfo.context = 'associateCandidates';
                        });
                        var index = _.findIndex(_this.selectedCandidates, {
                            id: basicCandidateInfo.id
                        });
                        if (index >= 0) {
                            basicCandidateInfo.selectedFlag = true;
                        }
                        else {
                            basicCandidateInfo.selectedFlag = false;
                        }
                        _this.candidates.push(basicCandidateInfo);
                    });
                    // if the length of the returned values is less than page size, it means there are not enough values.
                    // hence we can disable the infinite scroll
                    if (data.candidateMinimumInfoDtos.length < _this.searchObject.size || tempSearchObject.size != _this.defaultPageSize) {
                        _this.disableInfiniteScroll = true;
                    }
                    else {
                        _this.searchObject.page++;
                    }
                }
                else {
                    // if the length of the returned values is 0, it means there are no more values.
                    // hence we can disable the infinite scroll
                    _this.disableInfiniteScroll = true;
                }
                // set the candidates exist flag based on existence of candidates.
                if (_this.candidates.length > 0) {
                    _this.candidatesExistFlag = true;
                }
                else {
                    _this.candidatesExistFlag = false;
                }
            }
            //set this.busy to false
            _this.busy = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            // stop further infinite-scroll attempts when server returns error
            _this.disableInfiniteScroll = true;
            // indicate no candidates available after error to avoid repeated calls
            _this.candidatesExistFlag = false;
            _this.currentPromise = null;
            _this.busy = false;
        });
    };
    MatchedCandidatesContainer.prototype._setIsFilterOn = function (tempSearchObject) {
        var filter = tempSearchObject;
        if ((!filter.minimumScore && !filter.maximumScore && (filter.searchText.length > 0))
            || (!filter.searchText && (filter.minimumScore && filter.minimumScore > this.jobDetails.fourDotFiveIntelligenceScore))
            || (!filter.searchText && (filter.maximumScore && filter.maximumScore < 100))
            || (filter.numberOfDays && (filter.numberOfDays > 0))
            || filter.workLocationIds.length > 0
            || filter.sponsorships.length > 0
            || filter.jobTypes.length > 0
            || filter.jobSubTypes.length > 0
            || filter.sponsorships.length > 0
            || filter.salary > 0
            || filter.rate > 0
            || (filter.column != "" && filter.sortDirection != "")) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    };
    MatchedCandidatesContainer.prototype._getBasicCandidateInfo = function (candidate) {
        var basicCandidateInfo = {};
        basicCandidateInfo.name = candidate.contact.firstname + ' ' + candidate.contact.lastname;
        basicCandidateInfo.id = candidate.id;
        basicCandidateInfo.email = candidate.contact.email;
        basicCandidateInfo.mobilePhone = candidate.contact.mobilephone;
        basicCandidateInfo.workPhone = candidate.contact.workphone;
        basicCandidateInfo.matchScore = candidate.matchScore;
        basicCandidateInfo.candidateStatus = candidate.candidateStatus;
        if (!_.isNull(candidate.lastModifiedDate)) {
            basicCandidateInfo.lastModifiedDate = new Date(candidate.lastModifiedDate);
        }
        basicCandidateInfo.candidateJobMatches = [];
        basicCandidateInfo.jobMatchesPopoverPosition = 'bottom';
        if (_.isNull(basicCandidateInfo.matchScore)) {
            basicCandidateInfo.matchScore = 'N/A';
        }
        else {
            basicCandidateInfo.intelligenceScorePassFlag = false;
            if (basicCandidateInfo.matchScore >= this.jobDetails.fourDotFiveIntelligenceScore) {
                basicCandidateInfo.intelligenceScorePassFlag = true;
            }
            // round the match score to the lower integer value.
            basicCandidateInfo.matchScore = Math.floor(parseFloat(basicCandidateInfo.matchScore));
        }
        basicCandidateInfo.allowManualMatch = candidate.allowManualMatch;
        basicCandidateInfo.showOverride = candidate.showOverride;
        basicCandidateInfo.allowOverride = candidate.allowOverride;
        basicCandidateInfo.overrideFor = candidate.overrideFor;
        basicCandidateInfo.reasonForNoManualMatch = candidate.reasonForNoManualMatch;
        basicCandidateInfo.releaseDate = candidate.releaseDate;
        basicCandidateInfo.suspendedMonths = candidate.suspendedMonths;
        basicCandidateInfo.releasedCandidateDetail = candidate.releasedCandidateDetail;
        basicCandidateInfo.jobLeftDetail = candidate.jobLeftDetail;
        basicCandidateInfo.workLocations = candidate.workLocations;
        basicCandidateInfo.workLocationsMatchStatus = this.jobMatchService.getJobAndCandidateWorkLocationsMatchStatus(this.jobDetails.workLocations, candidate.workLocations);
        basicCandidateInfo.candidateAdditionalDetailsCard = candidate.candidateAdditionalDetailsCard;
        basicCandidateInfo.resumeExist = candidate.resumeExist;
        basicCandidateInfo.matchingMandatoryCriteria = candidate.matchingMandatoryCriteria;
        return basicCandidateInfo;
    };
    MatchedCandidatesContainer.prototype.getCandidateJobMatches = function (candidateId, userId, companyId, successCallback) {
        var candidateJobMatches = [];
        var jobMatchesObject = new JobMatchQueryFilter();
        jobMatchesObject.candidateId = candidateId;
        jobMatchesObject.userId = userId;
        jobMatchesObject.companyId = companyId;
        jobMatchesObject.top5Flag = false;
        jobMatchesObject.candidateType = "OWN_CANDIDATES";
        jobMatchesObject.searchText = '';
        jobMatchesObject.vendorIds = [];
        this.candidateService.getCandidateJobMatches(jobMatchesObject, 1, 250, function (data) {
            angular.forEach(data, function (val, key) {
                val.jobMatchDate = new Date(val.jobMatchDate);
                candidateJobMatches.push(val);
            });
            if (successCallback) {
                successCallback(candidateJobMatches);
            }
        }, function (error) {
            console.log('candidate job matches get error - ', error);
            // do nothing.
        });
    };
    return MatchedCandidatesContainer;
}());
export { MatchedCandidatesContainer };
var SearchObject = /** @class */ (function () {
    function SearchObject(jobId, companyId, size, associateCandidatesDefaultFilter, minimumScore) {
        this.requisitionId = jobId;
        this.companyId = companyId;
        this.size = size;
        this.searchText = "";
        this.page = "";
        this.minimumScore = minimumScore;
        this.maximumScore = 100;
        this.numberOfDays = 0;
        this.withoutJobMatchScore = false;
        this.includeCandidatesMatchingMandatoryCriteria = false;
        this.requestSource = associateCandidatesDefaultFilter.requestSource;
        this.workLocationIds = associateCandidatesDefaultFilter.workLocationIds;
        this.sponsorships = associateCandidatesDefaultFilter.sponsorships;
        this.jobTypes = associateCandidatesDefaultFilter.jobTypes;
        this.jobSubTypes = associateCandidatesDefaultFilter.jobSubTypes;
        this.salary = associateCandidatesDefaultFilter.salary;
        this.salaryDuration = associateCandidatesDefaultFilter.salaryDuration;
        this.rate = associateCandidatesDefaultFilter.rate;
        this.rateDuration = associateCandidatesDefaultFilter.rateDuration;
        this.salaryCurrency = associateCandidatesDefaultFilter.salaryCurrency;
        this.rateCurrency = associateCandidatesDefaultFilter.rateCurrency;
        this.column = associateCandidatesDefaultFilter.column;
        this.sortDirection = associateCandidatesDefaultFilter.sortDirection;
        this.includeCandidatesWithNoAdditionalDetails = associateCandidatesDefaultFilter.includeCandidatesWithNoAdditionalDetails;
        //this.column = 'matchScore';
        //this.sortDirection = 'DSC';
    }
    return SearchObject;
}());
//# sourceMappingURL=matched-candidates-infinite-scroll-container.js.map